import "./Card.css";

const Card = ({ title, description, image, onClick }) => {

	//console.log(image);
	return (
		<div className='card-container' style={{ backgroundImage: `url(${image})` }} onClick={onClick}>
			<div className='card-text'>
				<h2>{title}</h2>
				<p>{description}</p>
			</div>
		</div >
	);
};
export default Card;